(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-manager/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-manager/assets/javascripts/utils.js');
"use strict";


const {
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  useMemoizedSelector
} = svs.components.lbUtils.hooks;
const {
  Currency: currency
} = svs.utils.format;
const {
  productIds
} = svs.utils.products;
const {
  selectFundById
} = svs.components.sport.drawsRedux.selectors;
const {
  DRAW_STATE
} = svs.components.tipsen.drawCard.constants;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  DrawState,
  DisableType
} = svs.components.sport.tipsenShared;
const {
  makeSelectLeaguesAccumulatedFromDraw,
  makeSelectBetEventsFromDraw
} = svs.components.tipsen.selectors;
const {
  selectAllParticipants
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  SportTypes
} = svs.components.sport.sportTypes;
const {
  drawStateEnums,
  getDrawStateEnum
} = svs.components.sport.tipsenShared;
const composeHref = drawNumber => "/?draw=".concat(drawNumber);
const getIconBySportType = sportTypeId => {
  switch (sportTypeId) {
    case SportTypes.Soccer:
      return 'game-soccer';
    case SportTypes.Hockey:
      return 'game-hockey';
    case SportTypes.Bandy:
    case SportTypes.Floorball:
      return 'game-floorball';
    case SportTypes.Handball:
      return 'game-handball';
    case SportTypes.Basketball:
      return 'game-basketball';
    case SportTypes.Tennis:
      return 'game-tennis';
    case SportTypes.WinterOlympic:
      return 'game-winter';
    default:
      return 'game-sport';
  }
};
const isDrawBetDisabled = draw => {
  var _draw$regBetDisabled;
  return ((_draw$regBetDisabled = draw === null || draw === void 0 ? void 0 : draw.regBetDisabled) !== null && _draw$regBetDisabled !== void 0 ? _draw$regBetDisabled : DisableType.Regbet) === DisableType.NotDisabled;
};
const getDrawState = draw => {
  const isRegBetDisabled = isDrawBetDisabled(draw);
  const isOpened = draw.drawStateId === DrawState.Opened;
  const isCancelled = draw.cancelled;
  let state;
  if (!isRegBetDisabled) {
    state = DRAW_STATE.TEMPORARY_CLOSED;
  } else if (isCancelled) {
    state = DRAW_STATE.CANCELLED;
  } else if (!isOpened) {
    state = DRAW_STATE.NOT_OPENED;
  } else if (getDrawStateEnum(state) === drawStateEnums.LIVE) {
    state = DRAW_STATE.IS_LIVE;
  }
  return state;
};
const getFundInfoToShow = fund => {
  const extraMoney = {};
  const jackpotValues = fund !== null && fund !== void 0 && fund.jackpots ? fund.jackpots[0] : undefined;
  const extraMoneyFromFund = fund !== null && fund !== void 0 && fund.extraMoney && parseInt(fund.extraMoney, 10) > 0 ? fund.extraMoney : undefined;
  const rollOverInFromFund = fund !== null && fund !== void 0 && fund.rolloverIn && parseInt(fund.rolloverIn, 10) > 0 ? fund.rolloverIn : undefined;
  if (jackpotValues && !(jackpotValues !== null && jackpotValues !== void 0 && jackpotValues.defaultJackpot)) {
    extraMoney.isJackpot = true;
    extraMoney.amount = currency(jackpotValues.jackpotAmount);
  } else if (jackpotValues !== null && jackpotValues !== void 0 && jackpotValues.defaultJackpot) {
    extraMoney.isGuaranteeJackpot = true;
    extraMoney.amount = currency(jackpotValues.guaranteedJackpotAmount);
  } else if (extraMoneyFromFund) {
    extraMoney.isExtraMoney = true;
    extraMoney.amount = currency(extraMoneyFromFund);
  } else if (rollOverInFromFund) {
    extraMoney.isRolloverIn = true;
    extraMoney.amount = currency(rollOverInFromFund);
  }
  if (fund.productId === productIds.FULLTRAFF && (rollOverInFromFund || extraMoneyFromFund)) {
    extraMoney.isExtraMoneyAndJackpot = true;
    extraMoney.amountForExtraMoneyWithJackpot = rollOverInFromFund || extraMoneyFromFund;
  }
  return extraMoney;
};
const getLeagueInfo = leaguesAccumulatedInOrder => {
  const hasLeaguesToShow = (leaguesAccumulatedInOrder === null || leaguesAccumulatedInOrder === void 0 ? void 0 : leaguesAccumulatedInOrder.length) > 0;
  if (!hasLeaguesToShow) {
    return null;
  }
  const leagueNameToShow = leaguesAccumulatedInOrder[0].name || leaguesAccumulatedInOrder[0].uniqueLeagueName;
  const hasMoreThanOneLeague = leaguesAccumulatedInOrder.length > 1;
  const leagueToShow = hasMoreThanOneLeague ? "".concat(leagueNameToShow, " +").concat(leaguesAccumulatedInOrder.length - 1) : leagueNameToShow;
  return leagueToShow;
};
const composeTitle = (drawComment, description, productId, betIndex) => {
  const isBomben = productId === productIds.BOMBEN;
  let title = isBomben ? drawComment : description;

  const bombenDefaultTestPattern = /^Bomben, [234] matcher$/i;
  if (isBomben && betIndex > 0) {
    if (bombenDefaultTestPattern.test(title) || title.toLowerCase().trim() === 'bomben') {
      title = "Bomben ".concat(betIndex);
    }
  }
  return title;
};
const useComposeBetEventsWithParticipants = (betEvents, drawId) => {
  const allParticipants = useSelector(selectAllParticipants);
  return useMemo(() => {
    const uniqueMatchIds = new Set();

    const uniqueBetEvents = betEvents.filter(betEvent => {
      if (betEvent.eventTypeId === EventTypeId.RESULT && uniqueMatchIds.has(betEvent.matchId)) {
        return false;
      }
      uniqueMatchIds.add(betEvent.matchId);
      return true;
    });
    return uniqueBetEvents.map(betEvent => {
      var _betEvent$participant;
      const [homeParticipantId, awayParticipantId] = (_betEvent$participant = betEvent === null || betEvent === void 0 ? void 0 : betEvent.participants) !== null && _betEvent$participant !== void 0 ? _betEvent$participant : [];
      const awayParticipant = allParticipants[awayParticipantId];
      const homeParticipant = allParticipants[homeParticipantId];
      return {
        betEventId: "".concat(drawId, "_").concat(betEvent.eventNumber),
        homeParticipant: {
          participantId: homeParticipantId,
          flagISO: homeParticipant.isoCode,
          name: homeParticipant.name
        },
        awayParticipant: {
          participantId: awayParticipantId,
          flagISO: awayParticipant.isoCode,
          name: awayParticipant.name
        }
      };
    });
  }, [allParticipants, betEvents, drawId]);
};
const composeDrawsForDrawSelector = draws => {
  const drawsData = draws.map(draw => {
    const {
      betIndex,
      currentNetSale,
      description,
      drawComment,
      drawNumber,
      drawStateId,
      productId,
      regCloseTime,
      sportType
    } = draw;
    const state = getDrawState(draw);
    const drawId = "".concat(productId, "_").concat(drawNumber);
    const selectLeaguesCountFromDraw = useMemoizedSelector(makeSelectLeaguesAccumulatedFromDraw, drawId);
    const leaguesAccumulatedInOrder = useSelector(selectLeaguesCountFromDraw);
    const league = getLeagueInfo(leaguesAccumulatedInOrder);
    const fund = useSelector(state => selectFundById(state, productId, drawNumber));
    const currentExtraMoney = getFundInfoToShow(fund);
    const title = composeTitle(drawComment, description, productId, betIndex);
    const selectBetEventsFromDraw = useMemoizedSelector(makeSelectBetEventsFromDraw, drawId);
    const betEvents = useSelector(selectBetEventsFromDraw);
    const composedBetEvents = useComposeBetEventsWithParticipants(betEvents, drawId);
    return {
      betEvents: composedBetEvents,
      drawNumber,
      drawStateId,
      extraMoney: currentExtraMoney,
      href: composeHref(drawNumber),
      icon: getIconBySportType(sportType),
      league,
      netSale: currentNetSale,
      productId,
      regCloseTime,
      state,
      title
    };
  });
  return drawsData;
};
setGlobal('svs.components.tipsen.drawManager.utils', {
  composeHref,
  composeDrawsForDrawSelector,
  getDrawState,
  getFundInfoToShow,
  getLeagueInfo
});

 })(window);